import { useFirestore, useUser } from "reactfire"
import { MonitorDashboard } from "../common/monitor"
import { DoxType } from "../../types/types";
import { Card, CardBody, CardHeader } from "@nextui-org/react";
import { collection, Firestore, getCountFromServer, getFirestore, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";

export const UserUsage = () => {
    const user = useUser();

    const [eCount, setECount] = useState(0);
    const [gCount, setGCount] = useState(0);
    const [cCount, setCCount] = useState(0);
    const [totalJobs, setTotalJobs] = useState(0);
    const [completedJobs, setCompletedJobs] = useState(0);
    const [failedJobs, setFailedJobs] = useState(0);
    useEffect(()=> {

        const getCountOfDBObj = async(coll:string, filter?:[string, string]) => {
            const firestore = getFirestore();
            const eRef = collection(firestore, coll);
            var q = query(eRef, where("createdBy", "==", user.data?.uid));
            if (filter) {
                q = query(eRef, where("createdBy", "==", user.data?.uid), where(filter[0], "==", filter[1]));
            }
            const eCount = await getCountFromServer(q);
            return eCount.data().count; 
        }

        const loadData= async () => { 
            if (!user) return; 
            getCountOfDBObj('extractors').then((eCount) => {
                setECount(eCount);
            });
            getCountOfDBObj('generators').then((gCount) => {
                setGCount(gCount);
            });
            getCountOfDBObj('comparators').then((cCount) => {
                setCCount(cCount);
            });
            getCountOfDBObj('jobs').then((totalJobs) => {
                setTotalJobs(totalJobs);
            });
            getCountOfDBObj('jobs', ['status', 'completed']).then((completedJobs) => {
                setCompletedJobs(completedJobs);
            });
            getCountOfDBObj('jobs', ['status', 'failed']).then((failedJobs) => {
                setFailedJobs(failedJobs);
            });
        }
        loadData();
    }, [user])

    if (!user)
        return <></>
    const obj = { id: user.data?.uid }

    const _dataCard = (title: string, value: string, bgcolor: string = "bg-primary-50") => (
        <Card className="bg-primary-50 xl:max-w-md rounded-xl shadow-md px-3 w-full">
            <CardHeader>
                <div className="flex gap-2.5 justify-center w-full">
                    <span className="uppercase font-bold text-tiny">{title}</span>
                </div>
            </CardHeader>
            <CardBody className="overflow-hidden">
                <div className="flex gap-2.5 py-2 justify-center w-full">
                    <span className=" text-2xl font-semibold">{value}</span>
                </div>
            </CardBody>
        </Card>
    )

    return (
        <>
            <div className="flex justify-between">
                <div className="text-2xl font-bold">{user.data?.displayName}</div>
            </div>
            <br></br>
            <div className="flex w-full min-h-[65vh]">
                <div className="grid grid-cols-5">
                    <div className="flex flex-col gap-2 mt-2 mx-4 col-span-1">
                        <h3 className="text-lg">Components</h3>
                        <div className="flex flex-col gap-2 mt-2 mx-4">
                            <div className="grid md:grid-cols-1 grid-cols-1 2xl:grid-cols-1 gap-5  justify-center w-full">

                                {_dataCard('DoxEx', eCount.toString())}

                                {_dataCard('DoxGen', gCount.toString())}

                                {_dataCard('DoxComp', cCount.toString())}
                            </div>
                        </div>
                        <h3 className="text-lg">Jobs</h3>
                        <div className="flex flex-col gap-2 mt-2 mx-4">
                            <div className="grid md:grid-cols-1 grid-cols-1 2xl:grid-cols-1 gap-5  justify-center w-full">

                                {_dataCard('Total Jobs', totalJobs.toString())}
                                {_dataCard('Completed Jobs', completedJobs.toString())}
                                {_dataCard('Failed Jobs', failedJobs.toString())}
                            </div>
                        </div>

                    </div>
                    <div className="flex flex-col gap-2 mt-2 mx-4 col-span-4">

                        <MonitorDashboard dox={obj as DoxType} />
                    </div>
                </div>
            </div>

        </>
    )
}